import { UtmsResource } from '@infra/utms';
import { EventTrackerAdapter } from '../event-tracker.adapter';
import { Informations } from '@app/pages/main-form/forms/informations/form/informations-form.types';

interface AppsFlyerInstance {
  postMessage?(content: string): void;
}

type CustomWindow = typeof window & {
  appsflyerEvent?: AppsFlyerInstance;
  appsflyerWaiter?: AppsFlyerInstance;
};

export class AppsFlyerEventAdapter implements EventTrackerAdapter {
  private window: CustomWindow = window;

  constructor(private utmResource: UtmsResource) {}

  async track<T extends Partial<Informations>>(eventName: string, eventData?: T) {
    const utms = this.utmResource.getUtms();

    let objPayload = {
      event_name: eventName,
      name: eventData!['name'],
      email: eventData!['email'],
      page_name: eventData!['company'],
      phone: eventData!['phone'],
      computer: eventData!['computer'] ? 'Sim' : 'Não',
      timestamp: new Date().getTime(),
      ...(utms as object),
    };

    this.window?.appsflyerEvent?.postMessage?.(JSON.stringify(objPayload));
    this.window?.appsflyerWaiter?.postMessage?.(JSON.stringify(objPayload));
  }
}
